export enum HOUSE_RULES_GROUP {
  CHILDREN_ALLOWED = 'children_allowed',
  EVENTS_ALLOWED = 'events_allowed',
  PETS_ALLOWED = 'pets_allowed',
  SMOKING_ALLOWED = 'smoking_allowed',
}
